export const CONNECTED_MATCH_POLISH_OVERLAY: Record<string, any> = {
  en: {
    connectedPolish: {
      connectIntro: "When you are ready, review what will be shared and create the invite. Adding more shared match details first gives both players a more complete record.",
      reviewConnect: "Review & connect",
      matchesConnectPrompt: "Connect this match with your opponent",
      hideOptions: "Hide connection options",
      completeness: "{{done}} of {{total}} shared sections completed",
      complete: "The shared match details are complete.",
      missing: "You can still add: {{sections}}",
      sectionBasics: "Basics & score",
      sectionTimeline: "Score timeline",
      sectionContext: "Context & conditions",
      connectNow: "Connect now",
      progressive: {
        step1: "You can connect this match now. Continue if you want to add the score timeline, opponent details and match context first.",
        step2: "The score timeline can now be included. Opponent details and match context can still make the shared record richer.",
        step3: "You have added opponent context. Match context and conditions can still be added before sharing.",
        step4: "The shareable match facts are ready. The next Performance Rating step stays private and is not sent to your opponent.",
        step5: "Everything that can be shared is ready. Smartwatch and health data in Step 6 always stay private.",
      },
    },
    connectedShared: { tennisSince: "You play tennis since" },
  },
  el: {
    connectedPolish: {
      connectIntro: "Όταν είσαι έτοιμος, έλεγξε τι θα κοινοποιηθεί και δημιούργησε την πρόσκληση. Όσο περισσότερα κοινά στοιχεία συμπληρώσεις πρώτα, τόσο πληρέστερος θα είναι ο αγώνας και για τους δύο παίκτες.",
      reviewConnect: "Έλεγχος & σύνδεση",
      matchesConnectPrompt: "Σύνδεσε αυτόν τον αγώνα με τον αντίπαλό σου",
      hideOptions: "Απόκρυψη επιλογών σύνδεσης",
      completeness: "{{done}} από {{total}} κοινές ενότητες συμπληρωμένες",
      complete: "Τα κοινά στοιχεία του αγώνα είναι πλήρη.",
      missing: "Μπορείς ακόμη να προσθέσεις: {{sections}}",
      sectionBasics: "Βασικά στοιχεία & σκορ",
      sectionTimeline: "Εξέλιξη σκορ",
      sectionContext: "Πλαίσιο & συνθήκες",
      connectNow: "Σύνδεση τώρα",
      progressive: {
        step1: "Μπορείς να συνδέσεις τον αγώνα από τώρα. Αν θέλεις, συνέχισε πρώτα με την εξέλιξη σκορ, τα στοιχεία αντιπάλου και το πλαίσιο του αγώνα.",
        step2: "Η εξέλιξη σκορ μπορεί πλέον να συμπεριληφθεί. Τα στοιχεία αντιπάλου και το πλαίσιο του αγώνα μπορούν ακόμη να εμπλουτίσουν την κοινή καταγραφή.",
        step3: "Έχεις προσθέσει στοιχεία αντιπάλου. Μπορείς ακόμη να προσθέσεις πλαίσιο και συνθήκες πριν τον συνδέσεις.",
        step4: "Τα κοινά στοιχεία του αγώνα είναι πλέον έτοιμα. Το επόμενο βήμα, Performance Rating, παραμένει ιδιωτικό και δεν αποστέλλεται στον αντίπαλο.",
        step5: "Ό,τι μπορεί να κοινοποιηθεί είναι έτοιμο. Τα δεδομένα smartwatch και υγείας στο Βήμα 6 παραμένουν πάντοτε ιδιωτικά.",
      },
    },
    connectedShared: { tennisSince: "Παίζεις τένις από" },
  },
  es: {
    connectedPolish: {
      connectIntro: "Cuando estés listo, revisa qué se compartirá y crea la invitación. Añadir antes más datos compartidos del partido crea un registro más completo para ambos jugadores.",
      reviewConnect: "Revisar y conectar",
      matchesConnectPrompt: "Conecta este partido con tu rival",
      hideOptions: "Ocultar opciones de conexión",
      completeness: "{{done}} de {{total}} secciones compartidas completadas",
      complete: "Los datos compartidos del partido están completos.",
      missing: "Aún puedes añadir: {{sections}}",
      sectionBasics: "Datos básicos y marcador",
      sectionTimeline: "Evolución del marcador",
      sectionContext: "Contexto y condiciones",
      connectNow: "Conectar ahora",
      progressive: {
        step1: "Ya puedes conectar este partido. Si quieres, continúa primero con la evolución del marcador, los datos del rival y el contexto del partido.",
        step2: "La evolución del marcador ya puede incluirse. Los datos del rival y el contexto aún pueden enriquecer el registro compartido.",
        step3: "Has añadido contexto del rival. Aún puedes añadir el contexto y las condiciones del partido antes de compartirlo.",
        step4: "Los datos compartibles del partido ya están listos. El siguiente paso, Performance Rating, es privado y no se envía al rival.",
        step5: "Todo lo que puede compartirse está listo. Los datos de smartwatch y salud del Paso 6 siempre son privados.",
      },
    },
    connectedShared: { tennisSince: "Juegas al tenis desde" },
  },
  fr: {
    connectedPolish: {
      connectIntro: "Quand vous êtes prêt, vérifiez ce qui sera partagé puis créez l’invitation. Ajouter d’abord davantage de données communes rend le match plus complet pour les deux joueurs.",
      reviewConnect: "Vérifier et connecter",
      matchesConnectPrompt: "Connecter ce match avec votre adversaire",
      hideOptions: "Masquer les options de connexion",
      completeness: "{{done}} sur {{total}} sections partagées complétées",
      complete: "Les informations partagées du match sont complètes.",
      missing: "Vous pouvez encore ajouter : {{sections}}",
      sectionBasics: "Informations de base et score",
      sectionTimeline: "Déroulement du score",
      sectionContext: "Contexte et conditions",
      connectNow: "Connecter maintenant",
      progressive: {
        step1: "Vous pouvez déjà connecter ce match. Si vous le souhaitez, ajoutez d’abord le déroulement du score, les informations sur l’adversaire et le contexte du match.",
        step2: "Le déroulement du score peut maintenant être inclus. Les informations sur l’adversaire et le contexte peuvent encore enrichir l’enregistrement partagé.",
        step3: "Vous avez ajouté des informations sur l’adversaire. Vous pouvez encore ajouter le contexte et les conditions avant le partage.",
        step4: "Les informations partageables du match sont prêtes. L’étape suivante, Performance Rating, reste privée et n’est pas envoyée à l’adversaire.",
        step5: "Tout ce qui peut être partagé est prêt. Les données smartwatch et santé de l’étape 6 restent toujours privées.",
      },
    },
    connectedShared: { tennisSince: "Vous jouez au tennis depuis" },
  },
  de: {
    connectedPolish: {
      connectIntro: "Wenn du bereit bist, prüfe die geteilten Angaben und erstelle die Einladung. Je mehr gemeinsame Matchdetails du vorher ergänzt, desto vollständiger ist der Eintrag für beide Spieler.",
      reviewConnect: "Prüfen & verbinden",
      matchesConnectPrompt: "Dieses Match mit deinem Gegner verbinden",
      hideOptions: "Verbindungsoptionen ausblenden",
      completeness: "{{done}} von {{total}} gemeinsamen Bereichen ausgefüllt",
      complete: "Die gemeinsamen Matchdetails sind vollständig.",
      missing: "Du kannst noch ergänzen: {{sections}}",
      sectionBasics: "Grunddaten & Ergebnis",
      sectionTimeline: "Spielverlauf",
      sectionContext: "Kontext & Bedingungen",
      connectNow: "Jetzt verbinden",
      progressive: {
        step1: "Du kannst dieses Match schon jetzt verbinden. Wenn du möchtest, ergänze vorher Spielverlauf, Gegnerdetails und Matchkontext.",
        step2: "Der Spielverlauf kann jetzt mit einbezogen werden. Gegnerdetails und Matchkontext können den gemeinsamen Eintrag noch ergänzen.",
        step3: "Du hast Gegnerkontext ergänzt. Matchkontext und Bedingungen können vor dem Teilen noch hinzugefügt werden.",
        step4: "Die teilbaren Matchdaten sind jetzt bereit. Der nächste Schritt, Performance Rating, bleibt privat und wird nicht an den Gegner gesendet.",
        step5: "Alles Teilbare ist bereit. Smartwatch- und Gesundheitsdaten in Schritt 6 bleiben immer privat.",
      },
    },
    connectedShared: { tennisSince: "Du spielst Tennis seit" },
  },
  it: {
    connectedPolish: {
      connectIntro: "Quando sei pronto, controlla cosa verrà condiviso e crea l’invito. Aggiungere prima più dettagli condivisi rende il match più completo per entrambi i giocatori.",
      reviewConnect: "Controlla e collega",
      matchesConnectPrompt: "Collega questo match con il tuo avversario",
      hideOptions: "Nascondi opzioni di collegamento",
      completeness: "{{done}} di {{total}} sezioni condivise completate",
      complete: "I dati condivisi del match sono completi.",
      missing: "Puoi ancora aggiungere: {{sections}}",
      sectionBasics: "Dati di base e punteggio",
      sectionTimeline: "Andamento del punteggio",
      sectionContext: "Contesto e condizioni",
      connectNow: "Collega ora",
      progressive: {
        step1: "Puoi già collegare questo match. Se vuoi, aggiungi prima l’andamento del punteggio, i dettagli dell’avversario e il contesto del match.",
        step2: "L’andamento del punteggio può ora essere incluso. I dettagli dell’avversario e il contesto possono ancora arricchire il record condiviso.",
        step3: "Hai aggiunto informazioni sull’avversario. Puoi ancora aggiungere contesto e condizioni prima della condivisione.",
        step4: "I dati condivisibili del match sono pronti. Il passaggio successivo, Performance Rating, resta privato e non viene inviato all’avversario.",
        step5: "Tutto ciò che può essere condiviso è pronto. I dati smartwatch e salute del Passaggio 6 restano sempre privati.",
      },
    },
    connectedShared: { tennisSince: "Giochi a tennis dal" },
  },
  ja: {
    connectedPolish: {
      connectIntro: "準備ができたら、共有される内容を確認して招待を作成してください。共有する試合情報を先に増やすほど、両選手にとって記録がより充実します。",
      reviewConnect: "確認して接続",
      matchesConnectPrompt: "この試合を対戦相手と連携",
      hideOptions: "接続オプションを閉じる",
      completeness: "共有セクション {{total}} 件中 {{done}} 件を入力済み",
      complete: "共有する試合情報は入力済みです。",
      missing: "まだ追加できます: {{sections}}",
      sectionBasics: "基本情報とスコア",
      sectionTimeline: "スコア推移",
      sectionContext: "状況とコンディション",
      connectNow: "今すぐ連携",
      progressive: {
        step1: "この時点で試合を連携できます。必要なら先にスコア推移、対戦相手情報、試合状況を追加できます。",
        step2: "スコア推移も共有記録に含められる状態です。対戦相手情報や試合状況を追加すると、さらに充実した記録になります。",
        step3: "対戦相手の情報が追加されました。共有前に試合状況やコンディションを追加できます。",
        step4: "共有できる試合情報は準備できています。次の Performance Rating は非公開で、対戦相手には送信されません。",
        step5: "共有できる情報はすべて準備できています。ステップ6のスマートウォッチ・健康データは常に非公開です。",
      },
    },
    connectedShared: { tennisSince: "テニス開始年" },
  },
};

